module.exports = __webpack_public_path__ + "static/media/Patner11.31455a33.svg";